import { useContext } from 'react'
import AuthContext from 'app/contexts/AuthServiceAuthContext'

const useAuth = () => useContext(AuthContext)

export default useAuth
